import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ palette, breakpoints }) => ({
  bottomBanner: {
    display: `flex`,
    flexDirection: `column`,
    justifyContent: `center`,
    alignItems: `center`,
    gap: rem(20),
    width: '100%',
    backgroundColor: palette.primary[900],
    borderRadius: rem(12),
    padding: rem(20),
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
    [breakpoints.up('lg')]: {
      padding: `${rem(40)} ${rem(60)}`,
      maxWidth: rem(1120),
    },
  },
  bottomTitle: {
    color: palette.neutral[200],
  },
  caption: {
    color: palette.neutral[300],
  },
}));
